export const SQUARE = 'square';
export const PAYPAL = 'paypal';
